import React, { FC, useContext, useEffect } from "react";
import { WithChildren } from "../../../../_metronic/helpers";
import {
  CODE,
  KEY_DS_DANH_MUC_TIEP_DON,
  LEVEL,
  LOAI_PHONG,
  SIMPLE_CATEGORY_TYPE,
  TERM_CLASS_IDS
} from "../../utils/Constant";
import { addIndexedDBItem, getIndexedDBItem } from "../../utils/IndexedDB";
import { AppContext } from "../../appContext/AppContext";
import {
  getAllDistricts,
  getAllProvinces,
  getAllSubDistricts, getAllSubDistrictsAllRelated,
  getListKhoaPhong,
  getSimpleCategory,
  getTermByClassId,
  getTermClasses
} from "../../utils/ServicesUtils";
import {
  getListDangKyKham,
  getListDanToc,
  getListQuocTich
} from "../../phan-he-tiep-nhan-thanh-toan/services/TiepNhanServices";
import {AxiosPromise, AxiosResponse} from "axios";
import { IDanhSachDanhMuc } from "../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { getObsComplexCategories } from "../../phan-he-danh-muc/DanhMucServices";
import { TERM_MODEL_TYPE } from "../../phan-he-danh-muc/const/constant";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "./_consts";

const CacheWrap: FC<WithChildren> = ({ children }) => {
  const { setIsLoading } = useContext(AppContext);
  const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
  const CLASS_IDS_DICH_VU = `${TERM_CLASS_IDS.XET_NGHIEM},${TERM_CLASS_IDS.CDHA},${TERM_CLASS_IDS.PTTT}`;

  const getData = (
    response: PromiseSettledResult<AxiosResponse<any>>,
    termType?: number | string
  ) => {
    const STATUS_FULFILLED = "fulfilled";
    if (STATUS_FULFILLED === response.status) {
      switch (termType) {
        case TERM_CLASS_IDS.KHAM_BENH:
          return (
            response?.value?.data?.data?.[0]?.terms?.find((item: any) => item?.code === 'KB')
              ?.subs ?? []
          );

        case TERM_CLASS_IDS.ICD10:
        case TERM_CLASS_IDS.KQDT:
        case CLASS_IDS_DICH_VU:
        case TERM_CLASS_IDS.Y_HOC_CO_TRUYEN:
        case SIMPLE_CATEGORY_TYPE.TINH_HUYEN_XA_CU:
          return response?.value?.data?.data || [];

        case TERM_CLASS_IDS.HTXT:
          return response?.value?.data?.data?.[0]?.terms;

        default:
          return response?.value?.data?.data?.content || [];
      }
    }
    return [];
  };

  const handleCacheDsDanhMuc = async () => {
    try {
      setIsLoading(true);
      const [
        responseProvinces,
        responseDistricts,
        responseSubDistricts,
        responseSubDistrictsAllRelated, // Xã xũ
        responseDoiTuong,
        responseGioiTinh,
        responseQuocTich,
        responseDanToc,
        responseDKKham,
        responsePhongKham,
        responseTuyenKCB,
        responseKhamBenh,
        responseHTXT,
        responseKQDT,
        // responseYHocCoTruyen,
      ] = await Promise.allSettled([
        getAllProvinces(),
        getAllDistricts(),
        getAllSubDistricts(),
        getAllSubDistrictsAllRelated(),
        getSimpleCategory({ type: SIMPLE_CATEGORY_TYPE.DOI_TUONG }),
        getSimpleCategory({ type: SIMPLE_CATEGORY_TYPE.GIOI_TINH }),
        getListQuocTich(),
        getListDanToc(),
        getListDangKyKham(),
        getListKhoaPhong({ level: LEVEL.PHONG, type: LOAI_PHONG.PHONG_KHAM_BENH }),
        getSimpleCategory({ type: SIMPLE_CATEGORY_TYPE.TUYEN_KCB }),
        getTermClasses({classIds: TERM_CLASS_IDS.KHAM_BENH}),
        getTermClasses({ classIds: TERM_CLASS_IDS.HTXT }),
        getTermByClassId({ classId: TERM_CLASS_IDS.KQDT }),
        // getTermByClassId({ classId: TERM_CLASS_IDS.Y_HOC_CO_TRUYEN }),
      ]);

      let provinces = getData(responseProvinces);
      let districts = getData(responseDistricts);
      let subDistricts = getData(responseSubDistricts);
      let subDistrictsAllRelated = getData(responseSubDistrictsAllRelated, SIMPLE_CATEGORY_TYPE.TINH_HUYEN_XA_CU);
      let listDoiTuong = getData(responseDoiTuong);
      let listGioiTinh = getData(responseGioiTinh);
      let listQuocTich = getData(responseQuocTich);
      let listDanToc = getData(responseDanToc);
      let listDKKham = getData(responseDKKham);
      let listPhongKham = getData(responsePhongKham);
      let listTuyenKCB = getData(responseTuyenKCB);
      let listDichVu = getData(responseKhamBenh, TERM_CLASS_IDS.KHAM_BENH);
      let listHTXT = getData(responseHTXT, TERM_CLASS_IDS.HTXT);
      let listKQDT = getData(responseKQDT, TERM_CLASS_IDS.KQDT);
      // let listYHocCoTruyen = getData(responseYHocCoTruyen, TERM_CLASS_IDS.Y_HOC_CO_TRUYEN);

      const dsDanhMucResponse = {
        provinces,
        districts,
        subDistricts,
        subDistrictsAllRelated,
        listDoiTuong,
        listGioiTinh,
        listQuocTich,
        listDanToc,
        listDKKham,
        listPhongKham,
        listTuyenKCB: listTuyenKCB
          .map((item: any) => ({
            ...item,
            name: item.code ? `${item.code} - ${item.name}` : item.name,
          }))
          .sort((a: any, b: any) => a.code - b.code),
        listDichVu,
        listHTXT,
        listKQDT,
        // listYHocCoTruyen,
      };

      await new Promise<void>((resolve) => queueMicrotask(resolve));

      await addIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON, dsDanhMucResponse, setIsLoading);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    } finally {
    }
  };

  const handleGetHeavyData = async () => {
    try {
      const [
        responseICD10,
        responseYHocCoTruyen,
      ] = await Promise.allSettled([
        getTermByClassId({classId: TERM_CLASS_IDS.ICD10}),
        getTermByClassId({classId: TERM_CLASS_IDS.Y_HOC_CO_TRUYEN}),
      ]);

      const listICD10 = getData(responseICD10, TERM_CLASS_IDS.ICD10);
      let listYHocCoTruyen = getData(responseYHocCoTruyen, TERM_CLASS_IDS.Y_HOC_CO_TRUYEN);

      // Lấy dsDanhMuc hiện có từ IndexedDB (đã set bởi handleCacheDsDanhMuc trước đó)
      const dsDanhMuc: IDanhSachDanhMuc = (await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON)) || {};

      // Merge lại
      const newData = {
        ...dsDanhMuc,
        listICD10,
        listYHocCoTruyen,
      };

      // Ghi lại vào IndexedDB giống handleCacheDsDanhMuc
      await addIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON, newData, setIsLoading);

    } catch (err) {
      console.error("Error in handleGetHeavyData:", err);
    }
  };

  const handleGetDsDanhMuc = async () => {
    try {
      const responseDsDanhmuc: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      
      let hasEmptyArray = responseDsDanhmuc && Object.values(responseDsDanhmuc).some(
        (item: any[]) => item.length === 0
      );
        
      if (!responseDsDanhmuc || hasEmptyArray) {
        await handleCacheDsDanhMuc();
      }
      // setIsHasResponse(!hasEmptyArray)
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleCacheSpeakerConfig = async () => {
    try {
      const { data } = await getObsComplexCategories(TERM_MODEL_TYPE.DM_CAU_HINH_PHAT_LOA);
      if (CODE.SUCCESS === data?.code) {
        let speakerConfig = data?.data?.find((item: any) => (
          item?.user?.some((item: any) => item?.username === currentUser?.sub)
        ));
        speakerConfig && localStorageItem.set(KEY_LOCALSTORAGE.SPEAKER_CONFIG, speakerConfig);
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleInitCache = async () => {
    try {
      setIsLoading(true);
      await handleGetDsDanhMuc();
      await Promise.all([
        handleGetHeavyData(),
        handleCacheSpeakerConfig(),
      ]);
    } finally {
      setIsLoading(false); // chỉ tắt khi tất cả đều xong
    }
  }
  
  useEffect(() => {
    handleInitCache().then(r => r);
  }, []);

  return <>{children}</>
};

export default CacheWrap;
